import styled from "styled-components/macro";
import { darken } from "polished";

import Button from "../../components/Button";
import { BRAND } from "./brand";

/*
 * components/Button.js resolves its colors from the theme module directly
 * rather than from props.theme, so the page's ThemeProvider cannot reach it.
 * Repaint the brand-filled variant here instead of changing the shared
 * component, which every other page depends on.
 */
const BrandButton = styled(Button)`
  && {
    background-color: ${BRAND.primary};
    background-image: none;
    color: ${BRAND.secondary};
    text-shadow: none;

    &:hover {
      background-color: ${darken(0.08, BRAND.primary)};
    }
  }
`;

export default BrandButton;
